import DocumentDetails from "../components/DocumentsDetails"
import { LandingNavbar } from "../components/Homepage/landing-navbar"

const AssistantsDocumentsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <DocumentDetails />
        </div>
      </main>
    )
}

export default AssistantsDocumentsPage